import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { PlacetypesService } from 'src/app/services/core/placetypes/placetypes.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-list-placetypes',
  templateUrl: './list-placetypes.component.html',
  styleUrls: ['./list-placetypes.component.css']
})
export class ListPlacetypesComponent  implements OnInit {
  selectedStatus: any = ''
  placeTypeData: any = [];
  placeTypeId: any;
  filteredPlaceTypeList:any;
  totalPages = 0;
  totalResults = 0;
  currentPage:number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  search:any;
  status = true
  userPermission=UserPermission;
  placeTypeModalObj:any;

  constructor(private placetypesService: PlacetypesService, public permissionService: PermissionService){
    
  }

  ngOnInit(){
    this.getAllPlaceType(this.currentPage);
  }

  getAllPlaceType(page:number){
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.placetypesService.getPlaceType(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) =>{
      if(data.results ){
        this.placeTypeData = data.results;
        this.placeTypeData = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
      }
    })
  }
  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllPlaceType(page);
  }

  onSelectStatus(event: any): void {
   this.status = event.target.value === 'true';
    this.getAllPlaceType(this.currentPage = 1);
  }

  openPlaceTypeModal(placeType: any) {
    this.placeTypeModalObj = placeType;
  }

  onSavePlaceType(evt: any) {
    if (evt) {
      const idx = this.placeTypeData.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.placeTypeData[idx] = evt;
      } else {
        this.placeTypeData.splice(idx, 1);
      }
    }
    this.placeTypeModalObj = null;
  }

  onClosePlaceTypeModal() {
    this.placeTypeModalObj = null;
  }

}
